import { Grid } from "@mui/material";
import SocialIconsLinks from "UI/footer-common-links/social-icons";
import FooterLinks from "UI/footer-common-links/footerModal/footer-links";
import "./footer.scss";
import "../../scss/common.scss";

const Footer: React.FC = () => {

  return (
    <footer className="layoutFooter">
      <Grid container spacing={3} justifyContent="space-between" alignItems="center">
        <Grid item md={4} xs={12}>
          <p className="copyright text-white fs-14">
            Copyrights © 2022 All Rights Reserved by
            <span className="ppcn primary-color fs-16"> DriverTok</span>
          </p>
        </Grid>
        <Grid item  md={4} xs={12} justifyContent="center" className="social" alignItems='center'>
          <SocialIconsLinks />
        </Grid>
        <Grid item md={4} xs={12} className="footerEnd">
          <FooterLinks footerStyle='text-white' />
        </Grid>
      </Grid>
    </footer>
  );
};
export default Footer;